import dayjs from 'dayjs';
import lodash from 'lodash';
import { Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
import { onCreateFactoryUser } from '../system/userModel';
import { PromptController } from './prompt';
export class XiaozhiController {
  constructor() {
    this.Prompt = new PromptController(this);
  }
  /**
   * 用户信息
   * @memberof SystemController
   */
  readonly User = onCreateFactoryUser();
  Model = new BaseModel({ type: 'object' });
  HeaderSubject = null;
  SmallChat; //弹框
  Prompt; //推荐问
  get accessToken() {
    return lodash.get(this.Model.value, 'accessToken');
  }
  get requestTime() {
    return lodash.get(this.Model.value, 'requestTime');
  }
  get residueTime() {
    return lodash.get(this.Model.value, 'residueTime');
  }
  async onRecordPoint(route) {
    try {
      const userCode = lodash.get(this.User, 'userCode', 'bpp_visitor');
      const point = `bpp_${userCode}_${route}`;
      const headers = await this.getHeader();
      AjaxBasics.request({
        ...EnumAPI.lcicsp_router_record,
        headers,
        body: {
          route: point,
        },
      });
    } catch (error) {}
  }
  async getHeader() {
    if (this.HeaderSubject && !this.HeaderSubject.isStopped) {
      await this.HeaderSubject.toPromise();
    }
    this.HeaderSubject = new Subject();
    //是否过期
    let isExpire = true;
    if (this.accessToken) {
      const res = await this.checkToken();
      //token没过期
      if (!res) {
        isExpire = false;
      }
    }
    if (isExpire) {
      await this.getUserToken();
    }

    this.HeaderSubject.complete();
    if (this.accessToken) {
      return {
        'x-lcic-token': this.accessToken,
      };
    } else {
      throw '伙伴智能体token获取失败';
    }
  }
  /**
   * 获取token
   */
  async getUserToken() {
    try {
      const token = this.User.Auth.AccessToken;
      const ticket = token ? token : 'bpp_visitor';
      const source = token ? 'bpp' : 'bpp_visitor';
      const headers = {
        source,
        ticket,
      };
      const res = await AjaxBasics.request(
        lodash.assign({}, EnumAPI.admin_user, { headers }),
      );
      this.Model.merge({ accessToken: res });
    } catch (error) {}
  }
  /**
   * 校验token/刷新token
   * @returns
   */
  async checkToken(): Promise<Boolean> {
    try {
      const elapsedTime = dayjs().valueOf() - dayjs(this.requestTime).valueOf();
      //距离上次获取token已经过去多少秒
      const secTimestamp = Math.floor(elapsedTime / 1000);
      //不用重新校验token
      if (secTimestamp < this.residueTime / 2) {
        return false;
      }
      const headers = {
        'x-lcic-token': this.accessToken,
      };
      const res: TokenResponse = await AjaxBasics.request(
        lodash.assign({}, EnumAPI.check_token, { headers }),
      );
      const { token, residueTime } = res;
      if (token) {
        this.Model.merge({
          requestTime: dayjs().valueOf(),
          accessToken: token,
          residueTime,
        });
        return false;
      }
    } catch (error) {}
    return true;
  }
}
interface TokenResponse {
  /** 是否在黑名单中（false = 不在黑名单） */
  blacklistFlag: boolean;
  /** 剩余有效时间（单位：秒） */
  residueTime: number;
  /** 令牌字符串（JWT 格式示例） */
  token: string;
  /** 令牌是否有效（false = 无效/未激活） */
  tokenFlag: boolean;
}
